import { render } from "./GuessTheBalancePage.vue?vue&type=template&id=2bc49731"
import script from "./GuessTheBalancePage.vue?vue&type=script&lang=js"
export * from "./GuessTheBalancePage.vue?vue&type=script&lang=js"

import "./GuessTheBalancePage.vue?vue&type=style&index=0&id=2bc49731&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__